<template>
	<div class="three-d-outer">
		<div v-show="(extraDataList && extraDataList.length) || (modelList && modelList.length)" :class="{fullscreen: isFullscreen}" class="three-d-body">
			<div class="header">
				<i class="iconfont texture icon-button daoao-icon" :class="{ active: underCutActive, disabled: !(underCutModalList && underCutModalList.length) }" @click="onUnCutTool" id="underCutEle">
					<xl-tooltip :content="underCutActive ? $txdo('undercut.close.compute') : $txdo('undercut.open.compute')">
						<svg class="icon svg-icon svg-daoao" aria-hidden="true">
							<use :xlink:href="`#icon-${underCutActive ? 'daoaojihuo' : 'daoao1'}`"></use>
						</svg>
					</xl-tooltip>
				</i>
				<xl-tooltip :content="active ? $txdo('modelData.hideTexture') : $txdo('modelData.showTexture')">
					<i class="iconfont texture icon-saomiaowenli icon-button" :class="{ active: active, disabled: underCutActive }" @click="texture"></i>
				</xl-tooltip>
				<xl-tooltip :content="cameraType === 'Perspective' ? $txdo('modelData.cameraOrthogonalPerspective') : $txdo('modelData.cameraPerspective')" placement="bottom">
					<i class="iconfont icon-button" @click="changeCamera" :class="{ disabled: underCutActive }">
						<svg class="icon svg-icon" aria-hidden="true">
		          <use :xlink:href="`#icon-${cameraType === 'Perspective' ? 'toushi' : 'zhengjiao'}`"></use>
		        </svg>
					</i>
				</xl-tooltip>
				<xl-tooltip :content="isFullscreen ? $txdo('modelData.cancelfullscreen') : $txdo('modelData.fullscreen')" placement="bottom">
					<i :class="`iconfont icon-${isFullscreen ? 'moxingxiaoping1' : 'moxingquanping1'} icon-button`" @click="toggleScr"></i>
				</xl-tooltip>
				<xl-tooltip :content="$t('button.reset')" placement="bottom">
					<i class="iconfont icon-yaoqiuzhongsao reset icon-button" @click="resetModel"></i>
				</xl-tooltip>
			</div>
			
			<div class="iframe-body" ref="iframeRef" :loading="iframeLoading" :element-loading-text="$t('common.loading') + '...'" element-loading-background="transparent">
				<iframe class="three-d-model" title="" :id="id"></iframe>
				<div class="iframe-back" v-if="sliderDragState"></div>
			</div>
			<div class="model-list" :class="{fade: listStatus}" v-if="!underCutActive">
				<template v-if="mainModelList && mainModelList.length">
					<div class="model-list-title">{{$txdo('modelData.modelList')}}</div>
					<div class="model-list-content">
						<!-- 340X -->
						<!-- <div v-if="antagonistRt && antagonistRt.length && antagonistRtValue" class="antagonistRt">
							<xl-select v-model="antagonistRtValue" @change="rtChange" :options="antagonistRt"></xl-select>
						</div> -->
						<modelItem v-for="item in mainModelList" :key="item.dfsID" v-bind="item"
							:status="item.previewStatus"
							@updateShowStatus="changeVisible(item)"
							@updateSliderDragState="changeSliderDragState"
							@update:progress="op => { item.progress = op; changeSlider(item) }"
							:percentage="percentage"
							@reloadModel="handleReload(item)"
						></modelItem>
						<!-- <div class="model-item" v-for="item in modelList" :key="item.dfsID">
							<xl-tooltip v-if="!item.loadingStatus || item.loadingStatus === 'success'" :content="item.showStatus ? $t('button.hide') : $t('button.check')" placement="top">
								<span :class="`iconfont icon-${item.showStatus ? 'a-yincangmoxingbeifen2' : 'yincangmoxingbeifen'} eye`" @click="changeVisible(item)"></span>
							</xl-tooltip>
							<xl-progress v-if="item.loadingStatus === 'loading'" class="process-icon" type="circle" :percentage="percentage" :width="27"/>
							<xl-tooltip v-if="item.loadingStatus === 'error'" :content="$txdo('modelData.modelLoad.text')" placement="top" :offset="12">
								<img class="loading-error" src="../assets/image/loading-error.svg" alt="" @click="handleReload(item)"/>
							</xl-tooltip>
							<xl-tooltip :content="item.attachTip || $txdo('design.model.defaultJaw')" placement="top">
								<div class="xl-image-outer" :class="{hide: !item.showStatus}">
									<xl-image :src="defaultPreviewImage" object="contain" v-if="props.previewType"></xl-image>
									<xl-image :src="modelIconList(item.detailType, item.classType)" object="contain" v-else></xl-image>
								</div>
							</xl-tooltip>
							<xl-slider class="model-op" :disabled="!item.showStatus" :format-tooltip="(e) => `${e}%`" v-model="item.progress" @mousedown="sliderDragState = true" @mouseup="sliderDragState = false" @change="changeSlider(item)"></xl-slider>
						</div> -->
					</div>
				</template>
				<!-- 340X -->
				<template v-if="extraDataList && extraDataList.length">
					<div class="model-list-title" style="margin-top: 8px;">{{$txdo('modelData.extraData')}}</div>
					<div class="model-list-content">
						<modelItem v-for="item in extraDataList" :key="item.dfsID" v-bind="item"
							:status="item.previewStatus"
							@updateShowStatus="changeVisible(item)"
							@updateSliderDragState="changeSliderDragState"
							@update:progress="op => { item.progress = op; changeSlider(item) }"
							:percentage="percentage"
							@reloadModel="handleReload(item)"
						></modelItem>
						<!-- <div class="model-item" v-for="item in extraDataList" :key="item.dfsID">
							<xl-tooltip :content="item.showStatus ? $t('button.hide') : $t('button.check')" placement="top">
								<span :class="`iconfont icon-${item.showStatus ? 'a-yincangmoxingbeifen2' : 'yincangmoxingbeifen'} eye`" @click="changeVisible(item)"></span>
							</xl-tooltip>
							<xl-tooltip :content="item.attachTip || $txdo('design.model.defaultJaw')" placement="top">
								<div class="xl-image-outer" :class="{hide: !item.showStatus}">
									<xl-image :src="modelIconList(item.detailType, item.classType)" object="contain"></xl-image>
								</div>
							</xl-tooltip>
							<xl-slider class="model-op" :disabled="!item.showStatus" :format-tooltip="(e) => `${e}%`" v-model="item.progress" @mousedown="sliderDragState = true" @mouseup="sliderDragState = false" @change="changeSlider(item)"></xl-slider>
						</div> -->
					</div>
				</template>
				<xl-tooltip :content="listStatus ? $t('button.show') : $t('button.hide')">
					<div class="model-list-arrow" @click="listStatus = !listStatus">
						<span :class="'iconfont icon-' + (listStatus ? 'a-jiantou-you2' : 'a-jiantou-you22')" ></span>
					</div>
				</xl-tooltip>
				<switch-view-angle @change="onViewChange"></switch-view-angle>
				<div class="design-result" v-if="showAiResult">
					<div class="result-title">{{ $txdo('design.modelData.aiResult') }}</div>
					<div class="model-list-wrap">
						<modelItem v-for="item in aiList" :key="item.dfsID" v-bind="item"
							:attachTip="item.attachTip || $txdo('design.modelData.designResult')"
							:status="item.previewStatus"
							@updateShowStatus="changeVisible(item)"
							@updateSliderDragState="changeSliderDragState"
							@update:progress="op => { item.progress = op; changeSlider(item) }"
							@reloadModel="handleReload(item)"
							:percentage="percentage"
						></modelItem>
						<modelItem v-if="!aiList.length" :empty="true"></modelItem>
					</div>
				</div>
				<!-- 人工设计结果 -->
				<div class="design-result" v-if="showManualResult">
					<div class="result-title">{{ $txdo('design.modelData.manualResult') }}</div>
					<div class="model-list-wrap">
						<modelItem v-for="item in manualList" :key="item.dfsID" v-bind="item"
							:attachTip="item.attachTip || $txdo('design.modelData.designResult')"
							:status="item.previewStatus"
							@updateShowStatus="changeVisible(item)"
							@updateSliderDragState="changeSliderDragState"
							@update:progress="op => { item.progress = op; changeSlider(item) }"
							:percentage="percentage"
							@reloadModel="handleReload(item)"
						></modelItem>
						<modelItem v-if="!manualList.length" :empty="true"></modelItem>
					</div>
				</div>
			</div>
			<!-- 倒凹模型列表 -->
			<div class="model-list unCut-model-list" :class="{ fade: listStatus }" v-if="underCutActive">
				<template v-if="underCutModalList && underCutModalList.length">
					<div class="model-list-title">{{ $txdo('modelData.modelList') }}</div>
					<div class="model-list-content">
						<div :class="['model-item', item.showStatus ? 'model-item-dis' : '']" v-for="item in underCutModalList" :key="item.dfsID">
							<xl-tooltip v-if="!item.loadingStatus || item.loadingStatus === 'success'" :content="item.showStatus ? $t('button.hide') : $t('button.check')" placement="top">
								<span :class="`iconfont icon-${item.showStatus ? 'a-yincangmoxingbeifen2' : 'yincangmoxingbeifen'} eye`" @click="changeUpLowerModel(item)"></span>
							</xl-tooltip>
							<xl-progress v-if="item.loadingStatus === 'loading'" class="process-icon" type="circle" :percentage="percentage" :width="27" />
							<xl-tooltip v-if="item.loadingStatus === 'error'" :content="$txdo('modelData.modelLoad.text')" placement="top" :offset="12">
								<img class="loading-error" src="../assets/image/loading-error.svg" alt="" @click="handleReload(item)" />
							</xl-tooltip>
							<xl-tooltip :content="item.attachTip" placement="top">
								<div class="xl-image-outer" :class="{ hide: !item.showStatus }">
									<xl-image src="../assets/image/preview-default.png" object="contain" v-if="props.previewType"></xl-image>
									<xl-image :src="modelIconList(item.detailType, item.classType)" object="contain" v-else></xl-image>
								</div>
							</xl-tooltip>
						</div>
					</div>
				</template>
				<xl-tooltip :content="listStatus ? $t('button.show') : $t('button.hide')">
					<div class="model-list-arrow" @click="listStatus = !listStatus">
						<span :class="'iconfont icon-' + (listStatus ? 'a-jiantou-you2' : 'a-jiantou-you22')"></span>
					</div>
				</xl-tooltip>
			</div>
			<!-- end 倒凹模型数据 -->
			<div class="m-UnCutTools" v-if="underCutActive">
				<xl-popup-guide
					:visible="paintScaleActive"
					class="paint-popover"
					placement="top"
					:noclose="true"
    			:width="145">
					<template #content>
						<div class="paint-slider">
							<xl-slider class="model-op" :min="1" :max="100" v-model="paintScale" :show-tooltip="false" @input="onPaintScaleChange" />
							<span class="num">{{ paintScale }}</span>
						</div>
					</template>
					<template #reference>
						<div class="tools">
							<xl-tooltip :content="$txdo('undercut.paint.hover')">
								<i class="iconfont texture icon-bishua icon-button" :class="{ active: paintActive }" @click="onPaint" id="unCutPaint"></i>
							</xl-tooltip>
							<xl-divider direction="vertical" />
							<xl-tooltip :content="$txdo('undercut.compute.hover')">
								<i class="iconfont texture icon-jisuan1 icon-button" :class="{ active: computedActive }" id="unCutCompute" @click="onCompute"></i>
							</xl-tooltip>
						</div>
					</template>
				</xl-popup-guide>
			</div>
			<!-- <div class="help">
				<xl-tooltip :content="$t('common.help')" placement="top">
					<span class="iconfont icon-zhongzhishitu2 icon-button" @click="helpShow = true"></span>
				</xl-tooltip>
			</div> -->
		</div>
		<no-data v-if="previewStaus === 'init' && (!extraDataList || !extraDataList.length) && (!modelList || !modelList.length)" top="50%">
			<template #text>
				<span>{{ $txdo('design.jaw.transalte' || '数据正在转换中，请稍后查看')}}</span>
			</template>
		</no-data>
		<no-data v-else-if="(!extraDataList || !extraDataList.length) && (!modelList || !modelList.length)" top="50%"></no-data>

		<hotkey-dialog v-model:visible="helpShow" />
	</div>
</template>
<script setup>
import { ref, watch, onUnmounted, computed } from 'vue';
import { XlTooltip, XlImage, XlSlider, XlMessage, XlSelect, XlProgress, XlLoading, XlDriver, XlPopupGuide, XlDivider } from '@shining3d/ui-components';
import switchViewAngle from './switchViewAngle.vue';
import hotkeyDialog from './hotkeyDialog.vue';
import { useFullScreen } from '../hooks/useFullScreen';
import { $getCdnUrl } from '../utils/common';
import { ShiningViewer, Plugins } from '@shining3d/shining-viewer';
import { useStore } from 'vuex';
import { nextTick } from '@vue/runtime-core';
import { useLang } from '@shining3d/common-module/utils/lang.js';
import { get } from 'lodash';
import NoData from './no-data.vue';
import '@shining3d/common-module/utils/index.scss'
import _get from 'lodash/get';
// import { $importImg } from '../utils/common.js';
import defaultPreviewImage from '../assets/image/preview-default.png';
import modelItem from './modelItem/index.vue';

import { useNotSrcFileList } from '../common/enum';
import smileFace from '../assets/image/smileFace.svg';
import otherJaw from '../assets/image/otherJaw.svg';
import abutmentLowerJaw from '../assets/image/abutmentLowerJaw.svg';
import abutmentUpperJaw from '../assets/image/abutmentUpperJaw.svg';
import copyDentureLowerJaw from '../assets/image/copyDentureLowerJaw.svg';
import copyDentureUpperJaw from '../assets/image/copyDentureUpperJaw.svg';
import faceLowerJaw from '../assets/image/faceLowerJaw.svg';
import faceUpperJaw from '../assets/image/faceUpperJaw.svg';
import impressionLowerJaw from '../assets/image/impressionLowerJaw.svg';
import impressionUpperJaw from '../assets/image/impressionUpperJaw.svg';
import lowerJaw from '../assets/image/lowerJaw.svg';
import lowerJawAestheticplate from '../assets/image/lowerJawAestheticplate.svg';
import lowerJawNum from '../assets/image/lowerJawNum.svg';
import lowerJawPerOp from '../assets/image/lowerJawPerOp.svg';
import lowerJawScanbody from '../assets/image/lowerJawScanbody.svg';
import scanBodyLowerJaw from '../assets/image/scanBodyLowerJaw.svg';
import scanBodyMark from '../assets/image/scanBodyMark.svg';
import scanBodyReplace from '../assets/image/scanBodyReplace.svg';
import scanBodyUpperJaw from '../assets/image/scanBodyUpperJaw.svg';
import totalJaw1 from '../assets/image/totalJaw1.svg';
import totalJaw2 from '../assets/image/totalJaw2.svg';
import totalJawAestheticplate from '../assets/image/totalJawAestheticplate.svg';
import totallJaw3 from '../assets/image/totallJaw3.svg';
import upperJaw from '../assets/image/upperJaw.svg';
import upperJawAestheticplate from '../assets/image/upperJawAestheticplate.svg';
import upperJawNum from '../assets/image/upperJawNum.svg';
import upperJawPerOp from '../assets/image/upperJawPerOp.svg';
import upperJawScanbody from '../assets/image/upperJawScanbody.svg';

// import '@shining3d/xl-element-plus/dist/index.css';

const { notSrcFileList } = useNotSrcFileList();

const { $t } = useLang( '@shining3d/app' );
const { $t: $txdo } = useLang( '@shining3d/xl-design-order' );

const store = useStore();
const loadingInstance = ref(null);
const iframeLoading = ref( false );
const active = ref( true );
const modelList = ref([]);
const underCutModalList = ref([]); // 倒凹模式下仅有的上、下颌模型数据
const listStatus = ref( false );
const id = ref( '3dModel' );
const { isFullscreen, toggle } = useFullScreen();
// 如果存在额外匹配，那么旋转角度全部设置0
const props = defineProps({
	nodataText: String,
	orthodonticState: Boolean,
	previewType: String,
	info: {
		type: Object,
		default: () => ({})
	},
	background: {
		type: String,
		default: '#fff',
	},
	medicalRecods: Boolean,
	noSort: {
		type: Boolean,
		default: false
	},
	showAiResult: Boolean,
	showManualResult: Boolean
});
let client = null;
const sliderDragState = ref( false );

const { firstUse } = store.state;
// const _id = _get( store, 'state.factorySelect.id', '' );
const helpShow = ref( false );
const iframeRef = ref( null );
const cameraType = ref( '' );
let nowProgress = 0;
const cameraHelp = ref( false );
const underCutActive = ref( false ); // 倒凹点击状态
const paintActive = ref( false );
const INIT_PAINT_SIZE = 50;
const paintScale = ref( INIT_PAINT_SIZE );
const computedActive = ref( false );
const currentModel = ref({}); // 倒凹开启时当前的模型
const computeHint = ref( false );
const brushData = ref({});
const paintScaleActive = ref( false );

const toggleScr = () => {
	toggle().then(() => {
		// emits( 'changeScreen', isFullscreen.value );
	});
};

// 重置数据
const resetData = () => {
	active.value = true;
	iframeLoading.value = false;
	loadingInstance.value?.close();
	changeLoadingText();
	listStatus.value = false;
	cameraType.value = '';
	previewStaus.value = '';
	underCutActive.value = false;
	paintActive.value = false;
	paintScaleActive.value = false;
	brushData.value = '';
	client?.plugin.undercut.setUndercutCalc({ state: false });
	clearListeners();
};

// 额外扫描
const extraDataList = ref([]);

const mainModelList = computed(() => modelList.value.filter(( item ) => item.resultType === 'origin'  || item.isMainModel ).sort(( a, b ) => a.detailType === 'upperJaw' ? -1 : 1));
const manualList = computed(() => modelList.value.filter(( item ) => item.resultType === 'manual' ));
const aiList = computed(() => {
	const res = modelList.value.filter(( item ) => item.resultType === 'ai' )
	res.sort(( a, b ) => {
		if( a.detailType === b.detailType ) {
			return a.toothNum - b.toothNum
		} else {
			return a.detailType === 'upperJaw' ? -1 : 1
		}
	})
	return res
});

// 动画时长
const animationDration = 600;

//视角切换
const onViewChange = async ( params, immediate = false, strict = false ) => {
	// 获取可见模型数据
	const visibleIdList = [...modelList.value, ...extraDataList.value].filter(( m ) => m.showStatus ).map(( item ) => item.dfsID );
	// 根据可见模型与视角，获取相机位置
	let paramsStr = '';
	try {
		paramsStr = JSON.stringify({ direction: params, idList: visibleIdList, strict });
	} catch ( error ) {
		console.log( 'JSON.stringify失败', { direction: params, idList: visibleIdList, strict });
	}
	if ( !paramsStr ) {
		return;
	}
	const config = await client.directionConfig( paramsStr );

	// 设置动画状态
	await client.setCameraTransition({
		duration: immediate ? 0 : animationDration,
		type: 'ease'
	});
	// 设置相机，进行动画
	await client.setSceneParam( config );
};

// 模型数据加载初始化
const loadingModel = async () => {
	if (( extraDataList.value && extraDataList.value.length ) || ( modelList.value && modelList.value.length )) {
		const jobs = [];
		// 倒凹模型数据，仅展示上、下颌. 排除掉 AI设计结果、人工设计结果
		underCutModalList.value = modelList.value.filter(( item ) => ['upperJaw', 'lowerJaw'].includes( item.detailType ) && (item.resultType === 'origin'  || item.isMainModel));

		// 同时加载模型数据和额外扫描数据
		[...modelList.value, ...extraDataList.value].forEach(( v, i ) => {
			if ( (v.detailType === 'upperJaw' || v.detailType === 'lowerJaw' ) && v.previewStatus !== 'failed' ) {
			// previewStatus 为failed 是ai文件生成失败的情况，不加载模型 目前唯一 2024-10-09
				jobs.push( new Promise(( resolve ) => {
					client.addModel({
						id: v.dfsID,
						url: $getCdnUrl({ bucket: v.bucket, dfsID: v.dfsID }),
						type: v.resultType === 'ai' || v.resultType === 'manual' ? 'AI_3d_model' : 'tooth',
						visible: false,
						rotation: [0, 0, 0]
					}).then(( res ) => {
						resolve( res );
				 	}).
						catch(( e ) => {
							console.log( 'catch', e );
						});
				}));
			}
		});
		await Promise.all( jobs ).then( async () => {
			if ( !jobs.length ) {
				return;
			}
			client.setAutofitVisible( false );
			await setDefaultParams( true ); // 在模型加载后设置参数

			// 防止闪烁，加载模型时先隐藏，再调整相机，再展示模型
			await Promise.all([...modelList.value, ...extraDataList.value].map( async ( item, i ) => {
				if (( item.detailType === 'upperJaw' || item.detailType === 'lowerJaw' ) && item.showStatus ) {
					await client.setModelVisible( item.dfsID, item.showStatus );
				}
			}));

			changeLoadingText();
			iframeLoading.value = false;
			loadingInstance.value?.close();
			// 设计文件预览处不展示相机提示
			if ( !( props.previewType && props.previewType === 'designFilePreview' )){
				if ( firstUse && !firstUse.threeDModelCameraHelp ) {
					firstUse.threeDModelCameraHelp = true;
					store.commit( 'setFirstUse', firstUse );
					cameraHelp.value = true;
				}
			}
		});

		[...modelList.value, ...extraDataList.value].forEach(( v, i ) => {
			if ( v.detailType !== 'upperJaw' && v.detailType !== 'lowerJaw' && v.previewStatus !== 'failed' ) {
			// previewStatus 为failed 是ai文件生成失败的情况，不加载模型 目前唯一 2024-10-09
				v.loadingStatus = 'loading';
				loadModel.value = true;
				client.event.on( 'progress', modelProcess );
				client.addModel({
					id: v.dfsID,
		            url: $getCdnUrl({ bucket: v.bucket, dfsID: v.dfsID }),
					type: v.classType === 'faceScan' && realFaceModelList.indexOf( v.detailType ) > -1 ? 'face' : (v.resultType === 'ai' || v.resultType === 'manual') ? 'AI_3d_model' : 'tooth',
					visible: false,
					rotation: [0, 0, 0]
				}).then( async ( res ) => {
					if ( v.showStatus ) {
						client.setAutofitVisible( false );
						await setDefaultParams( true );
						await client.setModelVisible( v.dfsID, v.showStatus );

						changeLoadingText();
						iframeLoading.value = false;
						loadingInstance.value?.close();

						// 设计文件预览处不展示相机提示
						if ( !( props.previewType && props.previewType === 'designFilePreview' )){
							if ( firstUse && !firstUse.threeDModelCameraHelp ) {
								firstUse.threeDModelCameraHelp = true;
								store.commit( 'setFirstUse', firstUse );
								cameraHelp.value = true;
							}
						}
					}
					if ( res?.modelID ){
						v.loadingStatus = 'success';
					} else {
						v.loadingStatus = 'error';
						const name = v.attachTip || $txdo('design.model.defaultJaw');
						XlMessage({
							type: 'warning',
							message: name + $txdo( 'modelData.modelLoad.error' )
							// 模型加载失败，点击下载重试
						});
					}
				 }).
					catch(( e ) => {
						v.loadingStatus = 'error';
						const name = v.attachTip || $txdo('design.model.defaultJaw');
						XlMessage({
							type: 'warning',
							message: name + $txdo( 'modelData.modelLoad.error' )
							// 模型加载失败，点击下载重试
						});
						console.log( 'catch', e );
					});
			}
		});
	}

};
// 加载进度
const percentage = ref( 0 );
// 是否加载模型
const loadModel = ref( false );
// 加载失败的模型重新加载
const handleReload = ( val ) => {
	val.loadingStatus = 'loading';
	loadModel.value = true;
	client.event.on( 'progress', modelProcess );
	const name = val.attachTip || $txdo('design.model.defaultJaw');
	client.addModel({
		id: val.dfsID,
		url: $getCdnUrl({ bucket: val.bucket, dfsID: val.dfsID }),
		type: val.classType === 'faceScan' && realFaceModelList.indexOf( val.detailType ) > -1 ? 'face' : 'tooth',
		visible: val.showStatus,
		rotation: [0, 0, 0]
	}).then(( res ) => {
		if ( res?.modelID ){
			val.loadingStatus = 'success';
			XlMessage({
				type: 'success',
				message: name + $txdo( 'modelData.modelLoad.success' )
				// 模型加载成功
			});
		} else {
			val.loadingStatus = 'error';
			XlMessage({
				type: 'warning',
				message: name + $txdo( 'modelData.modelLoad.error' )
			});
		}
	}).
		catch(( e ) => {
			val.loadingStatus = 'error';
			XlMessage({
				type: 'warning',
				message: name + $txdo( 'modelData.modelLoad.error' )
				// 模型加载失败，点击下载重试
			});
			console.log( 'catch', e );
		});
};
const modelInit = () => {
	loadingModel();
	client?.use( new Plugins.Marker());
	client?.use( new Plugins.Undercut());
};

const changeLoadingText = ( progress ) => {
	if ( !iframeRef.value?.getElementsByClassName( 'el-loading-text' )[ 0 ]) {
		return;
	}
	let text = $t( 'common.loading' ) + '...';
	if ( progress || progress === 0 ) {
		nowProgress = Math.max( progress, nowProgress );
		text = `${$t( 'common.loading' )}...${Math.floor( nowProgress )}%`;
	} else {
		nowProgress = 0;
	}
	iframeRef.value.getElementsByClassName( 'el-loading-text' )[ 0 ].innerText = text;
};

const modelProcess = ( res ) => {
	changeLoadingText();
	if ( res ) {
		changeLoadingText( res.progress );
		percentage.value = 0;
		if ( loadModel.value && res.progress !== 100 ) {
			percentage.value = res.progress;
		}
	}
};

// 不需要展示的模型预览
const notShowDataList = ['FaceSmileForAlign', 'FaceOpenForAlign', 'FaceCustom1ForAlign', 'FaceCustom2ForAlign', 'FaceCustom3ForAlign', 'JawMotionStaticForAlign', 'JawMotionStaticForAlign', 'FaceSmileForAlign'];

// 展示特殊名称最后一个_到.中间内容
const setFileNameList = ['customFace0', 'customFace1', 'customFace2'];
// 真正需要做角度适配的面扫模型
const realFaceModelList = ['smileFace', 'staticFace', 'openFace', 'teethClippedSmileFace', 'exocadJawMotionFile', 'customFace0', 'customFace1', 'customFace2'];

// 多咬合关系
const antagonistRt = ref([]);
const antagonistRtValue = ref( '' );

// 模型是否在转换中状态
const previewStaus = ref('');
const setData = async ( data, info, rts, status ) => {
	resetData();

	previewStaus.value = status || '';
	// 340X
	// 判断是否存在多咬合
	if ( Array.isArray( rts ) && rts.length ) {
		antagonistRt.value = [{ id: 'default', rtName: $txdo( 'modelData.defaultRt' ) }, ...rts].map(( val ) => ({
			label: val.rtName,
			value: val.id,
			...val
		}));
		antagonistRtValue.value = 'default';
	} else {
		antagonistRt.value = [];
		antagonistRtValue.value = '';
	}
	// 340X
	if ( Array.isArray( data ) && data.length ) {
		// 某些类型展示文件名称
		data.forEach(( val ) => {
			if (['extraData', 'impressionUpperJaw', 'impressionLowerJaw', 'abutmentUpperJaw', 'abutmentLowerJaw'].indexOf( val.detailType ) > -1 ){
				if ( val.fileName || val.attachName ){
					val.attachTip = val.fileName || val.attachName;
				}
			} else if ( setFileNameList.indexOf( val.detailType ) > -1 ){
				const dashIndex = val.fileName.lastIndexOf( '-' );
				const dotIndex = val.fileName.lastIndexOf( '.' );
				if ( dashIndex > -1 && dotIndex > dashIndex ) {
					const result = val.fileName.substring( dashIndex + 1, dotIndex );
					result && ( val.attachTip = result );
				}
			}
		});
		modelList.value = data.
			filter(( v ) => v.detailType !== 'extraData' && !notShowDataList.includes( v.attachName?.toString().split( '.' )[ 0 ])).
			filter(( v ) => !notSrcFileList?.some(( val ) => v.srcFile?.indexOf( val ) > -1 )).
			map(( v, i ) => {
				v.progress = 100;v.showStatus = v.showStatus || false;return v;
			});
		// 获取额外扫描数据
		extraDataList.value = data.filter(( val ) => val.detailType === 'extraData' ).
			map(( v, i ) => ({ ...v, attachTip: v.fileName || v.attachName, progress: 100, showStatus: false }));
	}
	if ( modelList.value && modelList.value.length ){
		setModelVisibleByTooth( info?.tooths, props.previewType );
	} else if ( extraDataList.value && extraDataList.value.length ) {
		 extraDataList.value[ 0 ].showStatus = true;
	}
	if ( info && info.cameraType ) {
		cameraType.value = info.cameraType;
	}
	iframeLoading.value = true;
	loadingInstance.value = XlLoading.service({
		target: iframeRef.value,
		text: $t('common.loading') + '...',
		background: 'transparent',
	});
	if ( !client ) {
		nextTick( async () => {
			const threeModelUrl = get( window, 'app.global.threeModelUrl' );
			client = new ShiningViewer({
				container: id.value,
				background: props.background,
				access_token: '',
				appID: get( window, 'app.global.appId' ),
				url: threeModelUrl
				// url: 'http://10.20.58.65:4002/?debugger=1'
			});
			client.event.on( 'init', modelInit );
			client.event.on( 'progress', modelProcess );
		});
	} else {
		await clearModel();
		loadingModel();
	}
};

const setDefaultParams = async ( immediate = false, strict = false ) => {	
	// 设置默认参数（角度、位置、相机类型、相机参数）需要在addmodel 或者 setVisible回调中调用
	// strict参数代表动画是否要带偏移，正常情况下是要带上一点偏移的，如果需要严格视角数据，则strict需要传入true
	const showModels = [...extraDataList.value, ...modelList.value].filter(( v ) => v.showStatus );

	const hasFaceModel = showModels?.some(( model ) => model.classType === 'faceScan' && realFaceModelList.indexOf( model.detailType ) > -1 );
	if ( !cameraType.value ) { // 如未设置相机参数，则判断显示的模型中是否含有面扫模型，设置相机类型并在回调后修正视角，界面刚进入时调用，只有这一次
		if ( hasFaceModel ) {
			cameraType.value = 'Perspective';
		} else {
			cameraType.value = 'Orthographic';
		}
	  await client?.setCameraType( cameraType.value );
	}
	if ( showModels.length === 0 ) {
		// 如果没有可见模型，相机回到默认视角，正视图
		await onViewChange( 'envisage', true, strict );
	} else	if ( showModels.length === 1 ) {
		const detailType = showModels[ 0 ].detailType;
		// 判断上下颌设置相机位置
		if (['faceUpperJaw', 'upperJaw', 'upperJawPerOp', 'upperJawScanbody'].indexOf( detailType ) > -1 ) {
			await onViewChange( 'bottomView', immediate, strict );
		} else if (['faceLowerJaw', 'lowerJaw', 'lowerJawPerOp', 'lowerJawScanbody'].indexOf( detailType ) > -1 ) {
			await onViewChange( 'topView', immediate, strict );
		} else {
			await onViewChange( 'envisage', immediate, strict );
		}
	} else {
		// 如果存在多个可见模型，直接使用正视图
		await onViewChange( 'envisage', immediate, strict );
	}
};

// 上颌数据、类型
const upperJawList = ref([]);
const upperJawType = ['upperJaw', 'upperJawPerOp', 'upperJawScanbody', 'occlusalWaxUpperJaw', 'copyDentureUpperJaw', 'impressionUpperJaw', 'abutmentUpperJaw'];
// 下颌数据、类型
const lowerJawList = ref([]);
const lowerJawType = ['lowerJaw', 'lowerJawPerOp', 'lowerJawScanbody', 'occlusalWaxLowerJaw', 'copyDentureLowerJaw', 'impressionLowerJaw', 'abutmentLowerJaw'];
// 其他数据
const otherJawList = ref([]);
// 第二个参数判断是在accuware项目中
const setModelVisibleByTooth = ( tooth, type ) => {
	let upToothModelStatus = false;
	let downToothModelStatus = false;
	if ( tooth ){
		let teeth = [];
		if ( tooth instanceof Array ) {
			teeth = tooth;
		} else {
			teeth = tooth.split( ',' );
		}
		if ( !teeth.length || !modelList.value.length ) {
			return;
		}
		const upTeeth = ['18', '17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '28'];
		const downTeeth = ['38', '37', '36', '35', '34', '33', '32', '31', '41', '42', '43', '44', '45', '46', '47', '48'];
		teeth.forEach(( v ) => {
			if ( upTeeth.indexOf( v.toString()) > -1 ) {
				upToothModelStatus = true;
			} else if ( downTeeth.indexOf( v.toString()) > -1 ) {
				downToothModelStatus = true;
			}
		});
	}
	upperJawList.value = [];
	lowerJawList.value = [];
	otherJawList.value = [];
	modelList.value?.forEach(( v, i ) => {
		if ( upToothModelStatus && ['upperJaw'].indexOf( v.detailType ) > -1 ) {
			v.showStatus = true;
		}
		if ( downToothModelStatus && ['lowerJaw'].indexOf( v.detailType ) > -1 ) {
			v.showStatus = true;
		}
		// 拆分数据上颌、下颌、其他
		if ( upperJawType.indexOf( v.detailType ) > -1 ){
			upperJawList.value.push( v );
		} else if ( lowerJawType.indexOf( v.detailType ) > -1 ){
			lowerJawList.value.push( v );
		} else {
			otherJawList.value.push( v );
		}
	});
	// 上颌、下颌根据类型排序
	upperJawList.value.sort(( a, b ) => upperJawType.indexOf( a.detailType ) - upperJawType.indexOf( b.detailType ));
	lowerJawList.value.sort(( a, b ) => lowerJawType.indexOf( a.detailType ) - lowerJawType.indexOf( b.detailType ));
	// 下颌为工作颌排序为【下颌、上颌、其他】，其他情况全部为【上颌、下颌、其他】
	if ( !props.noSort ) {
		if ( downToothModelStatus ){
			modelList.value = [...lowerJawList.value, ...upperJawList.value, ...otherJawList.value];
		} else {
			modelList.value = [...upperJawList.value, ...lowerJawList.value, ...otherJawList.value];
		}
	}
	// 设计结果文件和上下颌文件默认打开展示
	if ( !( type && type === 'designFilePreview' )){
		// modelList.value[ 0 ].showStatus = true;
		modelList.value.forEach(item => {
			if ( item.feModelFileType === "designResult" || ['upperJaw', 'lowerJaw'].includes( item.detailType )) {
				item.showStatus = true;
			}
		});
	}
};
const isRt = ref( false );
// 多咬合切换
// const rtChange = ( rtId ) => {
// 	if ( rtId === 'default' ) {
// 		[...modelList.value, ...extraDataList.value].forEach(( val ) => {
// 			// 上颌下颌在切换时全部打开
// 			['lowerJaw', 'upperJaw'].indexOf( val.detailType ) > -1 && !val.showStatus && ( changeVisible( val ));
// 			// 1、模型角度归零
// 			client?.updateModelRotation( val.dfsID, [0, 0, 0]);
// 			client?.updateModelPosition( val.dfsID, [0, 0, 0]);
// 		});
// 	} else {
// 		isRt.value = true;
// 		const PromiseList = [];
// 		[...modelList.value, ...extraDataList.value].forEach(( val ) => {
// 			// 上颌下颌在切换时全部打开
// 			['lowerJaw', 'upperJaw'].indexOf( val.detailType ) > -1 && !val.showStatus && ( changeVisible( val ));
// 			PromiseList.push( new Promise(( resolve, reject ) => {
// 				// 1、模型角度归零
// 				client?.updateModelRotation( val.dfsID, [0, 0, 0]);
// 				client?.updateModelPosition( val.dfsID, [0, 0, 0]);
// 				resolve( '结束' );
// 			}));
// 		});
// 		Promise.all( PromiseList ).
// 			then(( val ) => {
// 				// 3、设置咬合位置即Rt
// 				const rtValue = antagonistRt.value.find(( item ) => item.value === rtId );
// 				// 4、获取切换颌id
// 				const rtIds = ( rtValue.isLowerJaw ? lowerJawList.value : upperJawList.value ).map(( item ) => item.dfsID );
// 				try {
// 					client.updateModelRTMatrix({ IDs: rtIds, RT: JSON.parse( rtValue.rt ) });
// 				} catch ( error ) {
// 					console.log( '多咬合切换失败：', error );
// 				}
// 			});
// 	}
// };

const imageFileList = {
	smileFace,
	otherJaw,
	abutmentLowerJaw,
	abutmentUpperJaw,
	copyDentureLowerJaw,
	copyDentureUpperJaw,
	faceLowerJaw,
	faceUpperJaw,
	impressionLowerJaw,
	impressionUpperJaw,
	lowerJaw,
	lowerJawAestheticplate,
	lowerJawNum,
	lowerJawPerOp,
	lowerJawScanbody,
	scanBodyLowerJaw,
	scanBodyMark,
	scanBodyReplace,
	scanBodyUpperJaw,
	totalJaw1,
	totalJaw2,
	totalJawAestheticplate,
	totallJaw3,
	upperJaw,
	upperJawAestheticplate,
	upperJawNum,
	upperJawPerOp,
	upperJawScanbody
};

const modelIconList = ( type, classType ) => {
	let result = '';
	result = imageFileList[type];
	if (!result) {
		if ( classType === 'faceScan' ) {
			result = smileFace;
		} else {
			// 默认的模型图标
			result = otherJaw;
		}
	}
	return result;
};

const resetModel = () => {
	// client?.reset();
	setDefaultParams();
};

const changeVisible = ( item ) => {
	if ( client ) {
		const prevIsEmpty = [...modelList.value, ...extraDataList.value].every(( v ) => !v.showStatus );
		// 非牙颌模型操作进行重置视角, 否则不重置。目前除UpperJaw(Upper Jaw Post-up)和LowerJaw(Lower Jaw Post-up)外类型均为非牙颌
		const dentalJawList = ['upperJaw', 'lowerJaw'];
		// 当前展示和操作的均为牙颌模型
		const isDentalJawFlag = dentalJawList.includes( item.detailType ) && [...modelList.value, ...extraDataList.value].filter(( v ) => v.showStatus ).every(( v ) => dentalJawList.includes( v.detailType ));
		item.showStatus = !item.showStatus;
		// 如果即将展示模型，那么先进行动画后展示模型
		// 如果即将隐藏模型，那么先隐藏模型后进行动画
		// 如果之前没有模型，要展示一个模型，那么不用进行动画，不用等待，直接展示模型
		if ( item.showStatus ) {
			if ( isRt.value ) {
				onViewChange( 'envisage', prevIsEmpty );
			} else if ( !isDentalJawFlag ) {
				// setDefaultParams( prevIsEmpty );
			}
			setTimeout(() => {
				client.setModelVisible( item.dfsID, item.showStatus );
			}, prevIsEmpty || isDentalJawFlag ? 100 : animationDration );
		} else {
			client.setModelVisible( item.dfsID, item.showStatus ).then(() => {
			// !isRt.value && setDefaultParams();
				if ( isRt.value ) {
					// 由于调用了client.setAutofitVisible( false )，setModelVisible将不会重置视角
					// 这里保持原有交互效果，原有setModelVisible会重置视角，这里直接使用正视图
					onViewChange( 'envisage' );
				} else if ( !isDentalJawFlag ){
					// setDefaultParams();
				}
			});
		}
	}

};

const changeSlider = ( item ) => {
	sliderDragState.value = false;
	client?.setModelOpacity( item.dfsID, item.progress / 100 );
};

const changeSliderDragState = ( state ) => {
	sliderDragState.value = state;
};

const clearModel = async () => {
	await Promise.all([client?.clear(), client?.plugin.marker?.clear()]);
};

const changeCamera = () => {
	if ( underCutActive.value ) {
		return;
	}
	cameraType.value = cameraType.value === 'Perspective' ? 'Orthographic' : 'Perspective';
	client?.setCameraType( cameraType.value );
};

const texture = () => {
	if ( underCutActive.value ) {
		return;
	}
	active.value = !active.value;
	if ( modelList.value && modelList.value.length ) {
		modelList.value.forEach(( v ) => {
			client?.setTextureType( v.dfsID, active.value ? 'colorful' : 'white' );
		});
	}
};

/** ---- 倒凹 ---- */
// 是否有上、下颌, 能否操作倒凹
const hasUpLowerJaw = () => {
	const hasUpper = underCutModalList.value.some(( item ) => item.detailType === 'upperJaw' );
	const lowerList = underCutModalList.value.filter(( item ) => item.detailType === 'lowerJaw' );
	const upList = underCutModalList.value.filter(( item ) => item.detailType === 'upperJaw' );
	const hasLower = Boolean( lowerList.length );

	return {
		hasLower,
		lowerList,
		hasUpper,
		upList,
		canUnCut: hasLower && hasUpper
	};
};

const onUnCutTool = async () => {
	if ( !underCutModalList.value?.length ) {
		return;
	}
	underCutActive.value = !underCutActive.value;

	if ( underCutActive.value ) {
		// 隐藏其他模型，默认展示下颌模型
		const { hasLower, lowerList, upList } = hasUpLowerJaw();
		await Promise.all([...modelList.value, ...extraDataList.value].map( async ( item ) => {
			if ( (!['upperJaw', 'lowerJaw'].includes( item.detailType ) || (item.resultType && item.resultType !== 'origin'))  && item.showStatus ) {
				// 隐藏其他类型模型
				item.showStatus = false;
				await client.setModelVisible( item.dfsID, false );
			} else if ( item.detailType === 'lowerJaw' ) {
				if ( item.dfsID === lowerList[ 0 ].dfsID ) {
					// 有下颌的时候，默认展示第一个下颌
					item.showStatus = true;
					await client.setModelVisible( item.dfsID, true );
					currentModel.value = item;
				} else {
					// 其余下颌隐藏
					item.showStatus = false;
					await client.setModelVisible( item.dfsID, false );
				}
			} else if ( item.detailType === 'upperJaw' ) {
				if ( hasLower && item.showStatus ) {
					// 有下颌的时候，隐藏上颌
					item.showStatus = false;
					await client.setModelVisible( item.dfsID, false );
				}
				if ( !hasLower ) {
					if ( item.dfsID === upList[ 0 ].dfsID ) {
						item.showStatus = true;
						// 无下颌的时候，默认展示 第一个上颌
						await client.setModelVisible( item.dfsID, true );
						currentModel.value = item;
					} else {
						// 其余上颌隐藏
						item.showStatus = false;
						await client.setModelVisible( item.dfsID, false );
					}
				}
			}
		}));

		// 倒凹模式下只能使用 正交
		if ( cameraType.value === 'Perspective' ) {
			cameraType.value = 'Orthographic';
			await client?.setCameraType( cameraType.value );
		}
		// 倒凹模型下只能显示 纹理
		if ( !active.value ) {
			active.value = true;
			if ( modelList.value && modelList.value.length ) {
				modelList.value.forEach(( v ) => {
					client?.setTextureType( v.dfsID, 'colorful' );
				});
			}
		}
		setDefaultParams( false, true );
		// 上下颌模型都要重新改变透明度100
		underCutModalList.value.forEach(( v ) => {
			v.progress = 100;
			client?.setModelOpacity( v.dfsID, 1 );
		});

		client?.event.on( 'dbClick', onModeldbClick );
		client?.event.on( 'brushModel', onBrushModel ); // 画刷结束的通知回调
	} else {
		shotMap.value = {};
		paintActive.value = false;
		paintScaleActive.value = false;
		brushData.value = '';
		paintScale.value = INIT_PAINT_SIZE;
		client?.plugin.undercut.setUndercutCalc({ state: false });
		client?.event.off( 'dbClick', onModeldbClick );
		client?.event.off( 'brushModel', onBrushModel );
	}
};

const shotMap = ref({});
const changeUpLowerModel = async ( item ) => {
	if ( item.showStatus ) {
		return;
	}
	// 清除倒凹计算结果
	brushData.value = '';
	client?.plugin.undercut.setUndercutCalc({ state: false });
	currentModel.value = item;
	await Promise.all( underCutModalList.value.map( async ( i ) => {
		if ( paintActive.value && i.showStatus ) {
			// client.setUndercutBrushes({
			// 	state: false,
			// 	meshID: i.dfsID
			// });
		}
		if ( i.dfsID === item.dfsID ) {
			i.showStatus = true;
		} else {
			// 记录上一次的视角
			const res = await client.shot();
			shotMap.value[ i.dfsID ] = res.sceneParam;
			i.showStatus = false;
		}
		await client.setModelVisible( i.dfsID, i.showStatus );
	}));
	if ( shotMap.value[ item.dfsID ]) {
		await client.setCameraTransition({
			duration: animationDration,
			type: 'ease'
		});
		await client.setSceneParam( shotMap.value[ item.dfsID ]);
	} else {
		await setDefaultParams( false, true );
	}

	if ( paintActive.value ) {
		paintActive.value = false;
		paintScaleActive.value = false;
		paintScale.value = INIT_PAINT_SIZE;
	}
};

const onPaint = () => {
	// const state = paintActive.value;
	if ( paintActive.value ) {
		brushData.value = '';
		// 清楚倒凹画刷结果
		client?.plugin.undercut.clearUndercutRes();
	} else {
		paintScaleActive.value = true;
		client?.plugin.undercut.setUndercutBrushes({
			state: true,
			meshID: currentModel.value.dfsID,
			size: paintScale.value
		});
	}
	paintActive.value = !paintActive.value;
};

const onPaintScaleChange = ( num ) => {
	paintScale.value = num;
	client?.plugin.undercut.setUndercutBrushes({
		state: true,
		meshID: currentModel.value.dfsID,
		size: num
	});
};

const onCompute = () => {
	computedActive.value = !computedActive.value;

	if ( computedActive.value ) {
		if ( firstUse && !firstUse.underCutComputeHintState ) {
			firstUse.underCutComputeHintState = true;
			store.commit( 'setFirstUse', firstUse );
			computeHint.value = true;
			setTimeout(() => ( computeHint.value = false ), 5000 );
		}
	}

	doUndercutCalc();
};

const doUndercutCalc = () => {
	loadingInstance.value = XlLoading.service({
		text: $txdo('undercut.compute.loading'),
		background: 'rgba(255, 255, 255, 0.5)',
	});
	// 开始倒凹计算，防止太快loading不展现
	setTimeout(() => {
		client?.plugin.undercut.
			setUndercutCalc({
				state: true,
				meshID: currentModel.value.dfsID,
				data: brushData.value ? brushData.value : null
			}).
			then( async ( data ) => {
				computedActive.value = false;
				loadingInstance.value?.close();
				if ( paintActive.value ) {
					// 关闭模型画刷功能
					client?.plugin.undercut.setUndercutBrushes({ state: false });
				}

				if ( data?.state === 'success' ) {
					XlMessage({ type: 'success', message: $txdo( 'undercut.compute.success' ) });
				} else {
					computedActive.value = false;
					loadingInstance.value?.close();
					XlMessage({ type: 'error', message: $txdo( 'undercut.compute.fail' ) });
				}
			}).
			catch(() => {
				loadingInstance.value?.close();
				XlMessage({ type: 'error', message: $txdo( 'undercut.compute.fail' ) });
			});
	}, 500 );
};

const onBrushModel = ( res ) => {
	// 关闭调节大小的
	paintScaleActive.value = false;
	brushData.value = res.data; // 缓存画刷片面数据
	// 开始倒凹计算
	doUndercutCalc();
};

const onModeldbClick = () => {
	computedActive.value = true;
	doUndercutCalc();
};
/** end --- 倒凹 ---- */

const clearListeners = () => {
	client?.event.off( 'init', modelInit );
	client?.event.off( 'progress', modelProcess );
};

const shot = () => client?.shot();

onUnmounted(() => {
	client?.destroy();
});

defineExpose({ setData, shot, clearListeners, iframeLoading });
</script>
<style lang="scss" scoped>
.three-d-outer {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
}
.three-d-body {
	width: 100%;
	height: 100%;
	position: relative;
	background-color: #fff;
	z-index: 99;
	overflow: hidden;
	&.fullscreen {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		.three-d-model{
			width: 100%;
			height: 100%;
		}
	}
	.model-list {
		position: absolute;
		width: 254px;
		top: 16px;
		max-height: calc(100% - 88px);
		border-radius: 0px 12px 12px 0px;
		box-shadow: 0px 2px 10px 0px rgba(17, 27, 51, .05);
		padding: 0 16px 8px;
		z-index: 999;
		box-sizing: border-box;
		transition: transform .5s ease-in-out;
		display: flex;
		flex-direction: column;
		&::after {
			content: '';
			position: absolute;
			width: 200%;
			height: 200%;
			border: 1px solid $color-n5;
			border-left: none;
			transform: scale(.5);
			transform-origin: 0 0;
			border-radius: 0px 24px 24px 0px;
			top: 0;
			left: 0;
			background-color: $default-color;
			z-index: -1;
		}
		&.fade {
			transform: translateX(-100%);
		}
		.model-list-title {
			padding: 15px 0;
			border-bottom: 2px solid $color-n5;
			font-size: 16px;
			line-height: 24px;
			color: $color-n10;
			font-family: $font-family65;
		}
		.model-list-content {
			margin-top: 15px;
			overflow: auto;
			margin-right: -16px;
			padding-right: 16px;
			flex-grow: 1;
			line-height: 0;
			// 340X
			.antagonistRt{
				.xl-select{
					width: 100%;
					:deep(.el-input__inner){
						height: 32px;
						background-color: $color-b1 !important;
						border: 1px solid $color-b2 !important;
						box-shadow: none !important;
						color: $color-n9 !important;
						font-family: $font-family65 !important;
					}
					:deep(.el-input__inner:focus){
						box-shadow: none !important;
						border-color: $color-b3 !important;
					}
				}
			}
			.model-item {
				margin-top: 8px;
				background-color: $color-n1;
				border-radius: 6px;
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				height: 40px;
				&:first-child{
					margin-top: 0;
				}
				.iconfont {
					font-size: 20px;
					color: $color-n8;
					&.eye {
						margin-left: 12px;
						cursor: pointer;
					}
					&.icon-yincangmoxingbeifen {
						color: $color-n7;
						width: 40px;
						height: 40px;
						line-height: 40px;
						padding-left: 12px;
						padding-right: 10px;
						margin-left: 0;
					}
					&.icon-a-yincangmoxingbeifen2{
						width: 40px;
						height: 40px;
						line-height: 40px;
						padding-left: 12px;
						padding-right: 10px;
						margin-left: 0;
					}
				}
				.xl-image-outer {
					// margin-left: 10px;
					height: 34px;
					:deep(.xl-image) {
						width: 34px;
						height: 34px;
					}
					&.hide {
						opacity: .6;
					}
				}
				.model-op {
					flex-grow: 1;
					margin-left: 12px;
					margin-right: 12px;
				}
				.loading-error{
					padding-left: 12px;
					padding-right: 10px;
					line-height: 40px;
					cursor: pointer;
				}
				.process-icon{
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				:deep(.el-progress-circle) {
					height: 16px !important;
					width: 16px !important;
					margin: 0 14px;
				}
			}
		}
		.model-list-arrow {
			position: absolute;
			right: -22px;
			top: 50%;
			height: 62px;
			width: 22px;
			transform: translateY(-50%);
			cursor: pointer;
			// background-image: url('~@/assets/image/model-arrow-bg.svg');
			line-height: 62px;
			color: $color-n8;
			text-align: center;
			z-index: -2;
		}
        .design-result {
			.result-title {
				padding: 16px 0 8px 0;
				font-size: 12px;
				line-height: 18px;
				font-weight: 500;
				// color: var(--oem-color-n10);
				color: #737E99;
				font-family: 'aliFontT65', 'aliFontO65';
				margin-right: 16px;
			}
		}
	}
	.unCut-model-list {
		// top: 279px;
		width: 122px;
		padding-bottom: 16px;
		.model-list-content {
			.model-item {
				&.model-item-dis {
					background-color: #edf3ff;
					cursor: not-allowed;
					.iconfont {
						&.eye {
							cursor: not-allowed;
						}
					}
				}

				.xl-image-outer {
					margin-right: 12px;
				}
			}
		}
	}

	.header {
		color: $color-n9;
		padding: 0px 16px;
		height: 44px;
		box-sizing: border-box;
		text-align: right;
		position: absolute;
		top: 12px;
		right: 16px;
		// background-color: rgba(var(--oem-default-color-rgb), .7);
		background-color: #F7F8FA;
		z-index: 1;
		border-radius: 8px;
		display: flex;
		align-items: center;
		.iconfont {
			font-size: 24px;
			cursor: pointer;
			&.icon-button {
				cursor: pointer;
				width: 32px;
				height: 32px;
				line-height: 32px;
				border-radius: 4px;
				display: inline-flex;
				color: $color-n9;
				justify-content: center;
				align-items: center;
				&:hover {
					background-color: $color-n4;
				}
				&.active, &:active {
		      color: $color-b4;
					background-color: $color-b1;
				}
				svg {
					width: 24px;
					height: 24px;
				}
			}
			&.biaozhu {
				position: relative;
				.label-sum-num {
					position: absolute;
					top: -3px;
					font-size: 12px;
					line-height: 15px;
					text-align: right;
					right: -3px;
					background-color: $default-color;
					color: $color-n9;
					border-radius: 2px;
					@include font-family85();
					padding: 0 1px;
				}
				&.active {
					.label-sum-num {
						color: $color-b4;
					}
				}
			}
			&:not(:last-of-type) {
				margin-right: 8px;
			}
			&.texture.active {
				color: $color-b4;
			}
			&.reset {
				margin-left: 9px;
				position: relative;
				&::after {
					position: absolute;
					top: 8px;
					left: -8px;
					width: 1px;
					height: 20px;
					content: '';
					background-color: $color-n5;
				}
			}
			&.orthodontic.disabled {
				cursor: not-allowed;
				opacity: .5;
				&:active {
					color: inherit;
				}
			}
		}
	}

	.iframe-body {
		width: 100%;
		height: 100%;
		position: relative;
		line-height: 0;
		.iframe-back {
			position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
		}
		:deep(.el-loading-text) {
			line-height: 1.5;
			font-size: 12px;
			margin-top: 4px;
		}
	}
	.three-d-model {
		border: none;
		width: 100%;
		height: 100%;
	}
	.icon-button {
		cursor: pointer;
		width: 28px;
		height: 28px;
		line-height: 28px;
		text-align: center;
		border-radius: 6px;
		display: inline-block;
		color: $color-n9;
		&:hover {
			background-color: $color-n4;
		}
		&:active {
      color: $color-b4;
		}
		&.disabled {
			cursor: not-allowed;
			opacity: .5;
			&:active {
				color: inherit;
			}
		}
	}
	.help {
		position: absolute;
		bottom: 20px;
		right: 16px;
	}
	.m-UnCutTools {
		position: absolute;
		width: 145px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #fff;
		border: 2px solid #e4e7ed;
		border-radius: 27px;
		height: 44px;
		padding-right: 20px;
		padding-left: 20px;
		left: 50%;
		transform: translateX(-50%);
		bottom: 24px;
		.tools {
			display: flex;
			height: 40px;
			align-items: center;
			justify-content: center;
			:deep(.el-divider) {
				margin: 0 20px;
			}
		}
		.iconfont {
			font-size: 24px;
			cursor: pointer;
			&.icon-button {
				cursor: pointer;
				width: 32px;
				height: 32px;
				line-height: 32px;
				border-radius: 4px;
				display: inline-flex;
				color: $color-n9;
				justify-content: center;
				align-items: center;
				&:hover {
					background-color: $color-n4;
				}
				&.active,
				&:active {
					color: $color-b4;
					background-color: $color-b1;
				}
				svg {
					width: 24px;
					height: 24px;
				}
			}
			&.texture.active {
				color: $color-b4;
			}
		}
		:deep(.paint-popover) {
			box-sizing: border-box;
			min-width: 145px;
			padding: 2px 12px !important;
			background: #fff !important;
			.popover-box {
				display: flex;
			}
			.el-popper__arrow {
				left: -33px !important;
				&::before {
					background-color: #fff !important;
				}
			}
			.paint-slider {
				display: flex;
				flex: 1;
				justify-content: center;
				align-items: center;
				.el-slider {
					flex: 1;
					.el-slider__runway {
						height: 8px;
					}
					.el-slider__bar {
						height: 8px;
					}
					.el-slider__button-wrapper {
						top: -14px;
					}
					.el-slider__button {
						border-color: $color-b3;
						width: 12px;
						height: 12px;
					}
				}
				.num {
					color: $color-b4;
					margin-left: 8px;
				}
			}
		}
	}
}
.accept-three-model {
  .three-d-body {
    background-color: #fff;
	.header {
		background: #F7F8FA;
	}
  }
}
</style>
